import React, { useEffect } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';

function OAuthRedirectHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const getUser = async () => {
      try {
        const { username, signInDetails } = await getCurrentUser();
        console.log('✅ Logged in user:', username, signInDetails);
        navigate('/');
      } catch (error) {
        console.error('OAuth Redirect Error:', error);
        navigate('/membership/login');
      }
    };

    getUser();
  }, [navigate]);

  return <p>Processing login...</p>;
}

export default OAuthRedirectHandler;
